import { useState, useEffect, useContext } from 'react';
import PromotionsService from '../../services/promotionsService';
import useNotify from '../notify';

import { ShoppingCartContext } from './CartProvider';

const useAditionals = () => {
    const { sale: { businessId, branchCode, country, items } } = useContext(ShoppingCartContext);
    const [aditionals, setAditionals] = useState([]);
    const [loading, setLoading] = useState(false);
    const { Notify, variants } = useNotify();

    useEffect(() => {
        const searchAditionals = () => {
            setLoading(true);
            PromotionsService
                .GetAditionals(businessId, branchCode, country, items.map(i => i.refId))
                .then(aditionals => setAditionals(aditionals))
                .catch(() => Notify("Ocurrio un problema obteniendo al obtener las promociones adicionales", variants.ERROR));
        }

        if(businessId && branchCode && items.length > 0)
            searchAditionals();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchCode, items])

    return {
        aditionals,
        loading
    }
}

export default useAditionals;